import './crisis-card.scss';

function CrisisCard() {
    return (
        <div className="mantine-Paper-root mantine-Card-root mantine-napxfz" data-testid="crisis-support-card">
            <div className="mantine-871kzp">
                <div className="mantine-ThemeIcon-root mantine-ryo3mj">
                    <div className="mantine-Image-root mantine-yxmaw9" style={{ width: '1.5rem' }}>
                        <figure className="mantine-qenwvq mantine-Image-figure">
                            <div className="mantine-1iugybl mantine-Image-imageWrapper">
                                <img className="mantine-v6y353 mantine-Image-image" src="https://content.brightside.com/assets/emergency-info-GCCWLDJF.svg" alt="" style={{ objectFit: 'cover', width: '1.5rem', height: '1.5rem' }} />
                            </div>
                        </figure>
                    </div>
                </div>
                <div className="mantine-Card-cardSection mantine-1aqvkyb" >
                    <div className="mantine-Text-root mantine-1h89pgf">Your health is very important to us. If you are in distress or thinking about hurting yourself, please seek help using these crisis resources at any time.</div>
                </div>
                <div className="mantine-Card-cardSection mantine-1aqvkyb" >
                    <div className="mantine-Text-root mantine-1ygzipf">Visit</div>
                    <div className="mantine-Text-root mantine-1ybhdtn">A hospital near you</div>
                </div>
                <div className="mantine-Card-cardSection mantine-1aqvkyb" >
                    <div className="mantine-Text-root mantine-1ygzipf">Call</div>
                    <div className="mantine-Text-root mantine-1ybhdtn">Suicide &amp; Crisis Lifeline<br />988<br />Emergency Services<br />911</div>
                </div>
                <div className="mantine-Card-cardSection mantine-1aqvkyb" >
                    <div className="mantine-Text-root mantine-1ygzipf">Text</div>
                    <div className="mantine-Text-root mantine-1ybhdtn">The Crisis Text Line<br />741-741</div>
                </div>
            </div>
        </div>
    );
}

export default CrisisCard;
